import { isMobile } from 'react-device-detect'

export function MobileAssistantFormPowered(){

    if(!isMobile) return null
    
    return <img src='/assets/images/myk-law.png' width={65}/>

}